export const marketingCardClass =
  'rounded-[1.5rem] border border-brand-primary/10 bg-white shadow-[0_20px_60px_-55px_rgba(0,31,34,0.55)]';

export const marketingStatCardClass =
  'rounded-[1.25rem] border border-brand-primary/10 bg-white/90 p-6 shadow-[0_20px_60px_-55px_rgba(0,31,34,0.55)]';

export const marketingPlanBadgeClass =
  'rounded-full border border-brand-primary/10 bg-brand-bg px-3 py-1 text-xs font-bold uppercase tracking-[0.12em] text-[var(--ir-muted)]';

export const marketingTableShellClass =
  'overflow-x-auto rounded-[1.5rem] border border-brand-primary/10 bg-white shadow-[0_20px_60px_-55px_rgba(0,31,34,0.5)]';
